import { Enum } from '@/app/model/base/enum'

const values = {
  REJECTION: 125
}

class ClientStateIdTypes extends Enum {
  static isRejection (value) {
    return value === values.REJECTION
  }
}

export default ClientStateIdTypes.initEnum(values)
